export default "__VITE_ASSET__D1VP_oed__"